/*
*
* AJAX Form service
*
* */

import {selectDoc, ajax, selectArr} from "../utils/utils";

import {inputEmail, inputEmpty} from "./service.validator";

import {captchaMarkup} from "./service.markup";

const props = {
    authKey: null,
    gValue: null
}

/**
 *
 * @param inputsNames
 * @param formId
 * @param requestData
 * @returns {boolean}
 */
const validate = (inputsNames, formId, requestData) => {
    let error = false;
    inputsNames.map(inputNameSelector => {
        let input = selectDoc(`#${formId} [name="${inputNameSelector}"]`)
        if (input) {
            //Get error msg container
            let inputMsg = selectDoc(`.${input.id}-error`)
            if (inputMsg) {
                input.classList.remove('error')
                inputMsg.classList.remove('show')
                inputMsg.innerText = ''

                //Add value to request data
                requestData[inputNameSelector] = input.value;

                //Validate not empty input
                if (inputEmpty(input.value)) {
                    error = true;
                    input.classList.add('error')
                    inputMsg.innerText = "Field can't be empty."
                    inputMsg.classList.add('show')
                } else {
                    //Validate email format
                    if (input.id.includes('Email') || input.id.includes('email')) {
                        if (!inputEmail(input.value)) {
                            error = true;
                            input.classList.add('error')
                            inputMsg.innerText = "Please enter a valid email address."
                            inputMsg.classList.add('show')
                        }
                    }
                }
            } else {
                error = true;
            }
        }
    });
    return error
}

/**
 *
 * @param requestData
 * @param endpoint
 * @param htmlContainer
 * @param captchaContainer
 * @param messagesContainer
 * @param submit
 */
const submitForm = (
    requestData,
    endpoint,
    htmlContainer,
    captchaContainer,
    messagesContainer,
    submit) => {

    submit.style.opacity = '0.5';

    //Check if this a after captcha call (second time call)
    // and add the captcha keys if required.
    if (props.authKey && props.gValue) {
        requestData = {
            "authenticity_token": props.authKey,
            "g-recaptcha-response": props.gValue,
        }
    }

    //Prepare request data
    let formBody = []
    for (let input in requestData) {
        let encodedKey = encodeURIComponent(input),
            encodedValue = encodeURIComponent(requestData[input]);
        formBody.push(encodedKey + "=" + encodedValue);
    }

    //Make call
    ajax('POST',
        endpoint,
        formBody.join('&'),
        'application/x-www-form-urlencoded'
    ).then(function (response) {
        submit.disabled = false;
        response = JSON.parse(response).response;
        submit.style.opacity = '1';

        //If captcha is present on HTML response
        if (response.includes('shopify-challenge__container')) {
            //Append form response to DOM to search keys
            htmlContainer.innerHTML = response;
            //Extract keys
            let siteKey = '';
            props.authKey = selectDoc(`input[name='authenticity_token']`).value;
            selectArr(("script")).map(script => {
                if (script.innerHTML.includes('recaptchaCallback')) {
                    script.innerHTML.split(':').map(portion => {
                        if (portion.includes('size')) {
                            siteKey = portion.split(',')[0]
                        }
                    })
                }
            })
            //Remove form response from Dom
            htmlContainer.innerHTML = ''

            //Render captcha
            let scriptTag = document.createElement('script'),
                scriptTagTwo = document.createElement('script');
            scriptTagTwo.innerHTML = captchaMarkup(captchaContainer, siteKey)
            htmlContainer.appendChild(scriptTagTwo)
            scriptTag.src = 'https://www.recaptcha.net/recaptcha/api.js?onload=recaptchaCallbackCustom&amp;render=explicit&amp;hl=en';
            htmlContainer.appendChild(scriptTag)

            //Listen response
            window.addEventListener('captchaSuccessCustom', function () {
                let responseInput = document.querySelector('.g-recaptcha-response');
                props.gValue = responseInput.value
            }, false);
        }
        // If captcha is not present on HTML response
        else {
            //Clear captcha global keys
            props.gValue = null;
            props.authKey = null;

            //Append form response to DOM to search keys
            htmlContainer.innerHTML = response;
            //Extract response
            let messages = selectDoc('#default-messages-container', htmlContainer)
            if (messages) {
                messagesContainer.innerHTML = messages.innerHTML;
            } else {
                messagesContainer.innerHTML = 'If there is an account associated with this email, you will receive a link to reset your password.'
            }
            //Remove form response from Dom
            htmlContainer.innerHTML = ''
            if(selectDoc(`#${captchaContainer}`)) {
                selectDoc(`#${captchaContainer}`).innerHTML = '';
            }

            setTimeout(function () {
                submit.classList.add('success');
                submit.innerHTML = 'Submitted';
                // setTimeout(function () {
                //     location.reload();
                // }, 3000)
            }, 1000)
        }
    });
}

/**
 *
 * @param formId
 * @param submit
 * @param inputsNames
 * @param requestData
 * @param endpoint
 * @param htmlContainer
 * @param captchaContainer
 * @param messagesContainer
 */
export const callAjaxForm = (
    formId,
    submit,
    inputsNames,
    requestData,
    endpoint,
    htmlContainer,
    captchaContainer,
    messagesContainer
) => {
    //Disable button to avoid multiple requests
    submit.disabled = true;

    //Validate inputs data
    let error = validate(inputsNames, formId, requestData)

    //If form data is valid submit form via AJAX
    if (!error) {
        submitForm(
            requestData,
            endpoint,
            htmlContainer,
            captchaContainer,
            messagesContainer,
            submit
        )
    } else {
        submit.disabled = false;
        submit.style.opacity = '1';
    }
}


